function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23 27C22.3277 27.0088 21.6679 26.8181 21.104 26.452C20.6445 26.1444 20.5214 25.5225 20.829 25.063C21.1366 24.6035 21.7585 24.4804 22.218 24.788C22.4526 24.9346 22.7255 25.0084 23.002 25C23.614 25 24.002 24.672 24.002 24.5C24.002 24.328 23.614 24 23.002 24C21.4872 24.1243 20.1519 23.0123 20 21.5C20.1519 19.9885 21.4859 18.8769 23 19C23.6723 18.9912 24.3321 19.1819 24.896 19.548C25.1932 19.747 25.3617 20.0895 25.338 20.4464C25.3143 20.8033 25.102 21.1205 24.781 21.2784C24.4601 21.4363 24.0792 21.411 23.782 21.212C23.5479 21.0658 23.2759 20.992 23 21C22.388 21 22 21.328 22 21.5C22 21.672 22.388 22 23 22C24.5141 21.8769 25.8481 22.9885 26 24.5C25.8481 26.0115 24.5141 27.1231 23 27Z",
  fill: "#32D882"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M23 21C22.4477 21 22 20.5523 22 20V18C22 17.4477 22.4477 17 23 17C23.5523 17 24 17.4477 24 18V20C24 20.5523 23.5523 21 23 21Z",
  fill: "#32D882"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M23 29C22.4477 29 22 28.5523 22 28V26C22 25.4477 22.4477 25 23 25C23.5523 25 24 25.4477 24 26V28C24 28.5523 23.5523 29 23 29Z",
  fill: "#32D882"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14 23C14 27.9706 18.0294 32 23 32C25.3869 32 27.6761 31.0518 29.364 29.364C31.0518 27.6761 32 25.3869 32 23C32 18.0294 27.9706 14 23 14C18.0294 14 14 18.0294 14 23ZM16 23C16 19.134 19.134 16 23 16C24.8565 16 26.637 16.7375 27.9497 18.0503C29.2625 19.363 30 21.1435 30 23C30 26.866 26.866 30 23 30C19.134 30 16 26.866 16 23Z",
  fill: "#32D882"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M11 23.94H10.91C4.56661 23.3057 -0.173577 17.8221 0.116379 11.4537C0.406334 5.08536 5.62522 0.0552484 12 -1.81068e-06C18.2157 -0.0325302 23.4123 4.71826 23.936 10.912C23.9604 11.1768 23.8783 11.4404 23.7079 11.6446C23.5376 11.8488 23.2929 11.9767 23.028 12C22.4824 12.0344 22.0057 11.6351 21.944 11.092C21.3896 5.82906 16.8308 1.90927 11.5442 2.14995C6.2576 2.39064 2.07384 6.70846 1.99996 12C1.97306 17.1773 5.92919 21.506 11.088 21.944C11.6402 21.9677 12.0687 22.4347 12.045 22.987C12.0212 23.5393 11.5542 23.9677 11.002 23.944L11 23.94Z",
  fill: "#32D882"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M18.2 13H12C11.4477 13 11 12.5523 11 12V5C11 4.44772 11.4477 4 12 4C12.5523 4 13 4.44772 13 5V11H18.2C18.7523 11 19.2 11.4477 19.2 12C19.2 12.5523 18.7523 13 18.2 13Z",
  fill: "#32D882"
});

var SvgVenueManagment6 = function SvgVenueManagment6(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVenueManagment6, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/venue-managment6.2011f425.svg";
export { ForwardRef as ReactComponent };